<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>


<div mat-dialog-content>

  <h1 mat-dialog-title>Add User</h1>
  <form [formGroup]="registerForm">
    <!-- <h1 mat-dialog-title>Register User</h1> -->

    <!-- Username Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" type="text" />
      <mat-error *ngIf="registerForm.get('username')?.hasError('required')">
        Username is required.
      </mat-error>
    </mat-form-field>

    <!-- Email Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Email</mat-label>
      <input matInput formControlName="emailId" type="email" />
      <mat-error *ngIf="registerForm.get('emailId')?.hasError('required')">
        Email is required.
      </mat-error>
      <mat-error *ngIf="registerForm.get('emailId')?.hasError('email')">
        Please enter a valid email address.
      </mat-error>
    </mat-form-field>

    <!-- Password Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" />
      <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
        Password is required.
      </mat-error>
    </mat-form-field>

    <!-- Mobile Number Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Mobile Number</mat-label>
      <input matInput formControlName="mobileNo" type="text" />
      <mat-error *ngIf="registerForm.get('mobileNo')?.hasError('required')">
        Mobile number is required.
      </mat-error>
    </mat-form-field>

    <!-- Role Field -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role">
        <mat-option *ngFor="let role of roles" [value]="role">
          {{ role }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="registerForm.get('role')?.hasError('required')">
        Role is required.
      </mat-error>
    </mat-form-field>

    <!-- Register Button -->
    <div class="button-group">
      <button mat-raised-button color="primary" type="submit" (click) = "register()" [disabled]="isLoading">Register</button>
      <button mat-button color="warn" (click)="onCancel()">Cancel</button>
    </div>
  </form>
</div>
